import { MenuItem, TextField } from "@mui/material"
import useFetchJson from "../../../data/useFetchJson"
import { LoadingBox } from "@northpowerdev/np-react-utils"
import { useEffect, useState } from "react"

export function AssigneeSelect({assignee='', label='Select Assignee', helperText='', onChange, sx}) {
    
    const [orderedMahiUsers, setOrderedMahiUsers] = useState([])
    const {
        data: desktopInspectorMahiUsers, // E.g. [ { "id", "oid", "name", "email", "phone", "roles"; [], "lastLoginDate", "active", "account": {...} }, ... ]
        isLoading: inspectorsLoading,
    } = useFetchJson('/bff/decommissioned-lines-service/api/decommissioned-lines/get-inspectors', {}, true)

    useEffect(() => {
        const sortByName = (a, b) => {
            if (a.name < b.name) { return -1 }
            if (a.name > b.name) { return 1 }
            return 0
        }

        if (!desktopInspectorMahiUsers) {
            return
        }
        const orderedUsers = desktopInspectorMahiUsers.sort(sortByName)
        setOrderedMahiUsers(orderedUsers)
    }, [desktopInspectorMahiUsers])

    const handleAssigneeChange = (e) => {
        // setAssignee(e.target.value)
        onChange(e.target.value)
    }
    return (
        <LoadingBox loading={!desktopInspectorMahiUsers || inspectorsLoading}>
            <TextField
                select
                label={label}
                value={assignee}
                helperText={helperText}
                onChange={handleAssigneeChange}
                sx={{minWidth: '10em', ...sx}}
            >
                <MenuItem key='show-all' value={''}>Show All</MenuItem>
                <MenuItem key='show-unassigned' value={'Unassigned'}>Show Unassigned</MenuItem>
                {
                    orderedMahiUsers?.map((u,i) => {
                        return (
                            <MenuItem key={u.name} value={u.name}>{u.name}</MenuItem>
                        )
                    })
                }
            </TextField>
        </LoadingBox>
    )
}